import {
  SET_LOADING_NOTIF,
  GET_NOTIFS,
  GET_NOTIF_ITEM,
  ERROR_NOTIF,
} from "../types";
import axiosInstance from "../request";

export const getNotifs = () => async (dispatch) => {
  try {
    dispatch({type: SET_LOADING_NOTIF});

    const res = await axiosInstance.get(`${process.env.REACT_APP_NOTIFICATION_URL}/api/v1/notification/`, {headers: {}});

    dispatch({
      type: GET_NOTIFS,
      payload: res.data,
    });
  } catch (e) {
    dispatch({
      type: ERROR_NOTIF,
      payload: e.response,
    });
  }
};

export const getNotificationItem = (id) => async (dispatch) => {
  try {
    dispatch({type: SET_LOADING_NOTIF});

    const res = await axiosInstance.get(`${process.env.REACT_APP_NOTIFICATION_URL}/api/v1/notification/${id}/`, {headers: {}});
    dispatch({
      type: GET_NOTIF_ITEM,
      payload: res.data,
    });
  } catch (e) {
    dispatch({
      type: ERROR_NOTIF,
      payload: e.response,
    });
  }
};
